import {AbstractModel} from '../../../abstract-model';
import {ThemeSchemaStyle} from './theme-schema-style';
import {ThemeSchemaElement} from './theme-schema-element';

export class ThemeSchemaGroup extends AbstractModel implements ThemeSchemaElement {
  styles: ThemeSchemaStyle[] = [];
  description: string | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    return this;
  }

  getType(): string {
    return 'group';
  }
}
